export default "__VITE_ASSET__Blh5tn0L__"